define("settings/templates/groups/group/members", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="tAC--section u--m__t__lg">
    <div class="tAC--section__item">
      <div class="tAC--section__detail">
        <h3 class="u--m__b__xs u--m__t__0">
          {{t "shared_words.users"}}
        </h3>
        <p class="u--text--md u--m__0">
          {{t "account.groups.group.users.description"}}
          <LinkTo @route="users">
            {{t "shared_words.users"}}.
          </LinkTo>
        </p>
      </div>
      <div class="tAC--section__action">
        <LinkTo @route="groups.group.members.new" class="o--btn o--btn--primary u--float--right">
          {{t "account.groups.group.users.button"}}
        </LinkTo>
      </div>
    </div>
  </section>
  <section class="tAC--section">
    <Groups::Group::Members::Table @group={{this.group}} />
  </section>
  {{outlet}}
  */
  {
    "id": "Tq++HJ/j",
    "block": "[[[10,\"section\"],[14,0,\"tAC--section u--m__t__lg\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"tAC--section__item\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tAC--section__detail\"],[12],[1,\"\\n      \"],[10,\"h3\"],[14,0,\"u--m__b__xs u--m__t__0\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"shared_words.users\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--md u--m__0\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"account.groups.group.users.description\"],null]],[1,\"\\n        \"],[8,[39,1],null,[[\"@route\"],[\"users\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,0],[\"shared_words.users\"],null]],[1,\".\\n        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"tAC--section__action\"],[12],[1,\"\\n      \"],[8,[39,1],[[24,0,\"o--btn o--btn--primary u--float--right\"]],[[\"@route\"],[\"groups.group.members.new\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,0],[\"account.groups.group.users.button\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[10,\"section\"],[14,0,\"tAC--section\"],[12],[1,\"\\n  \"],[8,[39,2],null,[[\"@group\"],[[30,0,[\"group\"]]]],null],[1,\"\\n\"],[13],[1,\"\\n\"],[46,[28,[37,4],null,null],null,null,null]],[],false,[\"t\",\"link-to\",\"groups/group/members/table\",\"component\",\"-outlet\"]]",
    "moduleName": "settings/templates/groups/group/members.hbs",
    "isStrictMode": false
  });
});